import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import alertify from "alertifyjs";
import "./styles/WantedSearchCarousel.css";
import "./styles/HomeFeedSkeleton.css";
import * as actions from "../redux/actions/searchMissActions";
import { WantedSearchSkeleton } from "./HomeFeedSkeleton";
import ModalGodiwayer from "./ModalGodiwayer";
import UserAvatar from "./UserAvatar";

function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function WantedSearchCard({ item, wanting, onWant, onOpenProfile }) {
  const user = item.User;
  const username = user?.Username ? `@${user.Username}` : "";
  const displayName = user?.Name || "";

  return (
    <article className="wanted-search-card">
      <div className="wanted-search-card__user">
        <button
          type="button"
          className="wanted-search-card__user-trigger"
          onClick={() => onOpenProfile(user)}
        >
          <UserAvatar
            src={user?.Avatar}
            alt={displayName}
            verified={user?.Verified}
            user={user}
            size="md"
            imgClassName="wanted-search-card__avatar"
            initials={getInitials(displayName)}
          />
          <div className="wanted-search-card__identity">
            <strong className="wanted-search-card__name">{displayName}</strong>
            {username && (
              <span className="wanted-search-card__username">{username}</span>
            )}
          </div>
        </button>
        <span className="wanted-search-card__date">{item.CreatedAt}</span>
      </div>

      <p className="wanted-search-card__text" title={item.Text}>
        "{item.Text}"
      </p>

      <div className="wanted-search-card__footer">
        <button
          type="button"
          className={
            item.IUserWanted
              ? "wanted-search-card__btn wanted-search-card__btn--active"
              : "wanted-search-card__btn"
          }
          disabled={item.IUserWanted || wanting}
          onClick={() => onWant(item)}
        >
          {item.IUserWanted ? <FaHeart /> : <FaRegHeart />}
          <span className="wanted-search-card__btn-label">
            <Translate value="search_miss_want" />
          </span>
          <span className="wanted-search-card__btn-count">
            × {item.WantCount}
          </span>
        </button>
      </div>
    </article>
  );
}

class WantedSearchCarousel extends React.Component {
  state = {
    open_modal_profile: false,
    contact: {},
  };

  componentDidMount() {
    if (this.props.token && this.props.user_id) {
      this.props.LoadList(this.props.user_id, this.props.token);
    }
  }

  onOpenProfile = (user) => {
    if (!user) return;
    this.setState({
      open_modal_profile: true,
      contact: user,
    });
  };

  onCloseModalProfile = () => {
    this.setState({ open_modal_profile: false });
  };

  onWant = async (item) => {
    if (!this.props.token || item.IUserWanted) return;

    try {
      await this.props.AddWant(item.Id, this.props.user_id, this.props.token);
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { list, loading } = this.props;

    if (loading) {
      return <WantedSearchSkeleton />;
    }

    if (!list || list.length === 0) {
      return null;
    }

    return (
      <section className="wanted-search-section">
        <header className="wanted-search-section__header">
          <h2 className="wanted-search-section__title">
            <Translate value="home_most_wanted_title" />
          </h2>
          <p className="wanted-search-section__subtitle">
            <Translate value="search_miss_subtitle" />
          </p>
        </header>

        <div className="wanted-search-carousel">
          {this.props.list.map((item) => (
            <WantedSearchCard
              key={item.Id}
              item={item}
              wanting={this.props.wantingId === item.Id}
              onWant={this.onWant}
              onOpenProfile={this.onOpenProfile}
            />
          ))}
        </div>

        <ModalGodiwayer
          isOpen={this.state.open_modal_profile}
          onClose={this.onCloseModalProfile}
          item={this.state.contact}
          identityOnly
          showChatAction={false}
        />
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    list: reducer.searchMiss.list,
    loading: reducer.searchMiss.loading,
    wantingId: reducer.searchMiss.wantingId,
    error: reducer.searchMiss.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadList: (user_id, token) => dispatch(actions.loadList({ user_id, token })),
  AddWant: (search_miss_id, user_id, token) =>
    dispatch(actions.addWant({ search_miss_id, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WantedSearchCarousel);
